const SESSION_STORAGE_CADENZA_PREFIX = '$cadenza$';

/**
 * Wrapper class around {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage Window.sessionStorage}
 * Please use it all over the place where you would access the sessionStorage directly
 * The API is equivalent to the sessionStorage API
 * This was introduced in CADENZA-25255 because we have the need to distinguish
 * which keys were stored by Cadenza and which by CustomWebApplications using the same sessionStorage
 * because they live in the same origin (i.e. by using a reverse proxy). We need this to only delete
 * our own key/value-pairs from the sessionStorage when calling the {@link clear} method
 * (and not delete the key/value-pairs created from other CustomWebApplications with the same origin).
 */
class SessionStorage {

  /* eslint-disable no-restricted-globals */
  setItem (key: string, value: string) {
    sessionStorage.setItem(SESSION_STORAGE_CADENZA_PREFIX + key, value);
  }

  getItem (key: string) {
    return sessionStorage.getItem(SESSION_STORAGE_CADENZA_PREFIX + key);
  }

  removeItem (key: string) {
    sessionStorage.removeItem(SESSION_STORAGE_CADENZA_PREFIX + key);
  }

  clear () {
    for (const [ name ] of Object.entries(sessionStorage)) {
      if (name.startsWith(SESSION_STORAGE_CADENZA_PREFIX)) {
        sessionStorage.removeItem(name);
      }
    }
  }

}

export const cadenzaSessionStorage = new SessionStorage();
